import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Auth } from '../auth/auth';
import { SubscriptionDialogService } from '../services/subscription-dialog.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(Auth);
  const subscriptionDialogService = inject(SubscriptionDialogService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (typeof window !== 'undefined') {
        if (error.status === 401) {
          localStorage.removeItem('auth_token');
          authService.setAuthState(false);
          router.navigate(['/login']);
        } else if (error.status === 403) {
          router.navigate(['/account/suspended']);
        } else if (error.status === 417) {
          subscriptionDialogService.showSubscriptionDialog();
          // console.log('🚨 417 Error detected!', {
          //   status: error.status,
          //   url: req.url,
          //   pathname: window.location.pathname,
          //   method: req.method
          // });
          // console.log('🚨 Sending error to HttpErrorService');
          // const httpErrorService = inject(HttpErrorService);
          // httpErrorService.handleError(error);
          // console.log('🚨 Error sent to service');
        }
      }
      return throwError(() => error);
    })
  );
};